module.exports = __webpack_public_path__ + "static/swarovski-0c69227cd3d11c245f44f06de6eeb324.jpg";